export default __webpack_public_path__ + "static/media/6.7f4f924b.webp";